import { type News, NewsStatus } from '@maru44/huntre-utils/src/models/news'
import { getData } from '@maru44/huntre-utils/src/utils/data'
import { doc, getDoc, where } from 'firebase/firestore'
import { firestore } from 'src/utils/firebase'
import { type UsePaginatedCollectionOptions, usePaginatedCollection } from '../usePaginatedCollection'
import useSWR from '../useSWR'

export const useNews = (options: UsePaginatedCollectionOptions = {}) => {
  const listNews = usePaginatedCollection<News>('news', {
    ...options,
    additionalConstraints: [where('status', '==', NewsStatus.Public), ...(options.additionalConstraints ?? [])],
  })

  return { listNews }
}

export const useNewsDetail = (id: string) => {
  const getNews = useSWR(
    [`/news/${id}`, id],
    async () => {
      const ref = doc(firestore, `news/${id}`)
      const snap = await getDoc(ref)
      const data = getData<News>(snap)

      // Only return public or closed news
      if (data && (data.status === NewsStatus.Public || data.status === NewsStatus.Closed)) {
        return data
      }
      return null
    },
    {
      disabled: !id,
    },
  )

  return { getNews }
}
